import { $,_,Radio,Foundation } from '../../../vendor'
import InboomaBaseView from '../InboomaBaseView'
import InboomaBaseCollectionView from '../InboomaBaseCollectionView'
import { Notification,Biscuit } from '../../utils'

import PaginationBehavior from '../../behaviors/Behavior.Pagination'

import ContingentsItemProgressView from './ContingentsItemProgressView'
import ContingentsItemTpl from '../../templates/contingents/ContingentsItemTpl.html'

const ContingentsItemView = InboomaBaseView.extend({

  template : ContingentsItemTpl,
  className : 'inb-c-item inb-c-item--contingent row',

  ui : {
      dropdown : '.inb-dropdown',
      toggleBtn : '.inb-toggle-contingent-dd',
      statusSelect : '.inb-status-select select',
      removeResource : '.inb-resource .inb-resource__remove',
      removeContingent : '.inb-contingent__delete',
      progressBar : '.inb-contingent-progress',
  },

  events : {
    'change @ui.statusSelect' : '_statusChanged',
    'click .inb-toggle-details  ' : '_toggleResources',
    'click @ui.removeResource' : '_removeResource',
    'click @ui.removeContingent' : '_removeContingent',
    'click .inb-toggle-contingent-dd' : '_initDropdown',
  },

  templateContext () {
    return {
      _,
      resourcetype : this.options.resourcetypes.get(this.model.get('resourcetype_id')),
      size : this.model.getFormattedTags(),
        client_id: Biscuit.get('user.client_id')
    }
  },
  
  onBeforeRender () {

    if (this.getOption('toggleContingentById') == this.model.get('id')) {
      this.$el.addClass('toggled');
    }

  },

  _toggleResources (target) {

    $('#'+$(target.currentTarget).attr('data-inb-toggle'))
     .toggleClass('active');

    this.$el.toggleClass('toggled');
    
  },

  _getResourceById (rid) {

    let resource;

    _.each(this.model.get('resources').models, (_resource, key) => {
      if (_resource.get('id') == rid) {
        resource = _resource;
      }
    });

    return resource;
  },

  _statusChanged (target) {

    target.preventDefault();

    const t = $(target.currentTarget),
          resource = this._getResourceById(t.closest('.inb-resource').attr('data-inb-resource-id')),
          val = t.val();

    if (val != '') {

      resource.save({status:val},{patch:true});

      new Notification({
        message : this.t('updated_${a}',{a:this.t('resource')},'capital'),
        duration : 9000,
        type : 'success',
        closeable : true,
        icon : 'fi fi-check'
      });

    }

  },

  _removeResource (target) {

    if (confirm(this.t('really_remove'))) {

      const that = this,
            resource = this._getResourceById($(target.currentTarget).closest('.inb-resource').attr('data-inb-resource-id'));

      resource.destroy({
        success (model, response) {

          $(target.currentTarget).closest('.inb-resource')
                                 .fadeOut('fast');

          new Notification({
            message : that.t('removed_${a}',{a:that.t('resource')},'capital'),
            duration : 5000,
            closeable : true,
            icon : 'fi fi-check'
          });

        // if (resource.collection.length == 0) {
            that.render()
        //  }
        }
      });
    }
  },

  _removeContingent () {

      const that = this;

      if (confirm(this.t('really_remove'))) {
          this.model.destroy({
            success () {

              that.$el.fadeOut('fast').remove();

              new Notification({
                message : that.t('removed_${a}',{a:that.t('contingent')},'capital'),
                duration : 5000,
                closeable : true,
                icon : 'fi fi-check'
              });

              // @todo that.destroy();
        
            },
            error (__, response) {
              if (typeof response.responseJSON !== 'undefined') {
                if (typeof response.responseJSON.data !== 'undefined') {
                  if (typeof response.responseJSON.data.message !== 'undefined') {
                    alert(response.responseJSON.data.message);
                  }
                }
              }
            }
          });
      }

  },

  initialize () {

      const that = this;
      //let length = this.model.get('resources').length;

    /* _.each(this.model.get('resources'), (resource, key) => {
        // fixes #18088
        if (resource.get('contingent_id') == '') {
          delete that.model.attributes.resources[key];
          length--;
        }
      });*/

      //this.model.attributes.resources.length = length;

      this.model.on('changed change:resources', () => {
        that.render();
      });
  },

  onRender () {

      const resourcetype = this.options.resourcetypes
                                      .get(this.model.get('resourcetype_id'));

      if (typeof resourcetype !== 'undefined') {
      
          new ContingentsItemProgressView({
            el : this.getUI('progressBar'),
            model : this.model
          });

      }
  },

  _initDropdown () {
      this._dropdown = new Foundation.Dropdown(this.getUI('dropdown'));
  },

});

export default InboomaBaseCollectionView.extend({
    
    childView: ContingentsItemView,
    template: _.noop,
    clientHasLocations : false,

    ui : {
        'noLocationsFound' : 'body'//#inb-c-main-contingents__no-locations'
    },

    childViewOptions () {
        return {
            toggleContingentById : (typeof this.options.toggleId != 'undefined' ? this.options.toggleId : null),
            resourcetypes : Radio.channel('resourcetypes').request('get:data'),
        }
    },

    behaviors : [
        {
            behaviorClass: PaginationBehavior
        }
    ],

    initialize () {

      InboomaBaseCollectionView.prototype.initialize.apply(this);


        if (!this.options.widgetMode) {
            // LocationsView may still be present
            this.$el.html('');
        }

        this.render();
    },

    onRender () {

        $('.inb-c-loader').hide();

        if ($('.inb-c-item.toggled').length >= 1) {
            $('html,body').scrollTop($('.inb-c-item.toggled').offset().top - 50)
        }
    }

});